import {
  DatePicker,
  InfoItemHorizontal,
  InfoItemVertical,
  Input,
  TextArea,
  TextEditor,
} from "components";
import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { DateConvert } from "utilities";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { CloseSalesOrderApi } from "api";

export const InfoSection = ({ isSpk, action }) => {
  const { values, setValues, errors, touched } = useFormikContext();
  const [isNomorLoading, setIsNomorLoading] = useState(false);
  const [textEditorState, setTextEditorState] = useState(() =>
    EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML("<p></p>"))
    )
  );

  console.log(values);
  // console.log(isSpk);

  const getNomorHandler = (tgl) => {
    setIsNomorLoading(true);
    const tanggal = DateConvert(new Date(tgl)).default;

    CloseSalesOrderApi.getNomor({ tgl: tanggal, is_spk: isSpk })
      .then(({ data }) => {
        const no = data?.data;
        setValues({
          ...values,
          no_close_sales_order: no,
          tgl_close_sales_order: tanggal,
          is_spk: isSpk,
        });
      })
      .catch(() => {
        setValues({
          ...values,
          no_close_sales_order: "",
          tgl_close_sales_order: null,
        });
        window.alert("Nomor gagal dimuat");
      })
      .finally(() => {
        setIsNomorLoading(false);
      });
  };

  useEffect(() => {
    setTextEditorState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(values?.lain_lain ?? "<p></p>")
        )
      )
    );
  }, [values]);
  return (
    <>
      <Row>
        <Col>
          <InfoItemHorizontal
            label="Tgl. Peluang"
            text={
              values.tgl_peluang
                ? DateConvert(new Date(values?.tgl_peluang))?.detail
                : "-"
            }
          />
          <InfoItemHorizontal
            label="No. Peluang"
            text={values?.no_peluang ?? "-"}
          />
          <InfoItemHorizontal
            label="Peringkat Peluang"
            text={values?.nama_peringkat_peluanng ?? "-"}
          />
        </Col>
        <Col>
          <InfoItemHorizontal
            label="Customer"
            text={values?.nama_customer ?? "-"}
          />
          <InfoItemHorizontal label="ATT" text={values?.att ?? "-"} />
          <InfoItemHorizontal
            label="Proyek"
            text={values?.nama_proyek ?? "-"}
          />
          <InfoItemHorizontal
            label="Unit Produksi"
            text={values?.nama_unit_produksi ?? "-"}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <TextArea
            label="Keterangan Pengiriman"
            readOnly
            value={values?.keterangan_pengiriman ?? "-"}
          />
          <TextArea
            label="Lokasi Pengiriman"
            readOnly
            value={values?.lokasi_pengiriman ?? "-"}
          />
        </Col>
        <Col>
          <TextEditor
            readOnly
            label="Informasi Lainnya"
            editorState={textEditorState}
            options={[]}
            editorStyle={{ height: 120 }}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <InfoItemVertical
            label="Tgl. Sales Order"
            text={
              values.tgl_sales_order
                ? DateConvert(new Date(values?.tgl_sales_order))?.detail
                : "-"
            }
          />
        </Col>
        <Col>
          <InfoItemVertical
            label="No. Sales Order"
            text={values.no_sales_order ?? "-"}
          />
        </Col>
        <Col>
          <InfoItemVertical
            label="Tgl. Batas Akhir"
            text={
              values.batas_waktu
                ? DateConvert(new Date(values?.batas_waktu))?.detail
                : "-"
            }
          />
        </Col>
        <Col>
          <InfoItemVertical label="Sales" text={values?.nama_sales ?? "-"} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <DatePicker
            label="Tgl. Close Sales Order"
            dateFormat="dd/MM/yyyy"
            disabled={action === "read"}
            onChange={(date) => {
              getNomorHandler(date);
            }}
            selected={
              values?.tgl_close_sales_order
                ? new Date(values?.tgl_close_sales_order)
                : null
            }
            error={
              Boolean(errors?.tgl_close_sales_order) &&
              touched?.tgl_close_sales_order
            }
            errorText={
              Boolean(errors?.tgl_close_sales_order) &&
              touched?.tgl_close_sales_order &&
              errors?.tgl_close_sales_order
            }
          />
        </Col>
        <Col>
          <Input
            label="No. Close Sales Order"
            disabled
            value={
              isNomorLoading ? "Memuat Data.." : values?.no_close_sales_order
            }
            placeholder="Pilih tanggal terlebih dahulu"
            error={
              Boolean(errors?.no_close_sales_order) &&
              touched?.no_close_sales_order
            }
            errorText={
              Boolean(errors?.no_close_sales_order) &&
              touched?.no_close_sales_order &&
              errors?.no_close_sales_order
            }
          />
        </Col>
      </Row>
    </>
  );
};
